import { FC, Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { ECasinoGameMode } from 'interfaces/casino-data';
import { NewCasinoGame } from 'interfaces/new-casino';

const { GameViewMobileLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "casino-game-view-mobile-layout" */ './layouts/mobile'
    )
);

const { GameViewDesktopLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "casino-game-view-desktop-layout" */ './layouts/desktop'
    )
);

interface IGameViewProps {
  game: NewCasinoGame;
  mode: ECasinoGameMode;
  onModeChange: (mode: ECasinoGameMode) => void;
}

const IS_MOBILE_LAYOUT = isMobile();

export const GameView: FC<IGameViewProps> = ({ game, mode, onModeChange }) => {
  if (IS_MOBILE_LAYOUT) {
    return (
      <Suspense>
        <GameViewMobileLayout
          game={game}
          mode={mode}
          onModeChange={onModeChange}
        />
      </Suspense>
    );
  }

  return (
    <Suspense>
      <GameViewDesktopLayout
        game={game}
        mode={mode}
        onModeChange={onModeChange}
      />
    </Suspense>
  );
};
